<template>
  <div>
    <div v-show="selectedDiv === 'Invoice' || selectedDiv === 'All'">
      <div class="row">
        <div class="col-lg-12 mt-2 px-4">
          <div class="card dashboard-card">
            <div class="graph-body">
              <div class="card-body col-md-12 col-lg-12 col-xl-10">
                <div class="card-header">
                  <h6><i class="fa fa-line-chart text-primary"/>{{ $tc('dashboard.invoice_chart.title',2) }} </h6>
                  <div class="year-selector">
                    <base-select
                      v-model="selectedFunder"
                      :options="getFunders"
                      :searchable="true"
                      :show-labels="false"
                      :allow-empty="true"
                      :tabindex="8"
                      :placeholder="$t('dashboard.select_funder')"
                      label="name"
                      track-by="id"
                    />
                  </div>
                </div>
                <div class="row">
                  <div
                    v-if="isLoaded"
                    class="col-md-6"
                  >
                    <bar-chart
                      ref="chart1"
                      :label="'Invoices'"
                      :labels="labels"
                      :values="[...invoiceGroupCount]"
                      :background-color="bgColors"
                      :border-color="bgColors"
                      :hover-background-color="bgColors"
                      :hover-border-color="bgColors"
                    />
                  </div>
                  <div class="col-md-6">
                    <p class="text-center"> Total Credit Limit <span v-html="$utils.formatMoney(total_credit_limit, defaultCurrency)"/></p>
                    <pie-chart
                      v-if="isLoaded"
                      :labels="CrditLimitLabels"
                      :values="CreditLimitData"
                      :bg-colors="CreditLimitBgColors"
                      :hover-bg-colors="hoverBgColors"
                      :type="'pie'"
                    />
                  </div>
                </div>
                <div class="description">
                  <h6 class="title"> {{ $t('dashboard.total_amount_financed') }} </h6>
                  <br>
                  <span v-if="isLoaded" class="total">
                    <div v-html="$utils.formatMoney(financedAmount, defaultCurrency)"/>
                  </span>
                </div>
              </div>
              <div class="chart-desc col-md-12 col-lg-12 col-xl-2">
                <div class="stats">
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.pending') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#334CFF;">
                      <div v-html="invoiceGroupCount[0]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.offered') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#E333FF;">
                      <div v-html="invoiceGroupCount[1]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.financed') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#33FF71;">
                      <div v-html="invoiceGroupCount[2]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.prepaid') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#F9FF33;">
                      <div v-html="invoiceGroupCount[3]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.settlement') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#FFB233;">
                      <div v-html="invoiceGroupCount[4]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.rejected') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#FF3F33;">
                      <div v-html="invoiceGroupCount[5]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.eligible') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total" style="color:#FF3F33;">
                      <div v-html="invoiceGroupCount[6]"/>
                    </span>
                  </div>
                  <div class="description">
                    <span class="title"> {{ $t('dashboard.invoice_chart.total_invoice') }} </span>
                    <br>
                    <span v-if="isLoaded" class="total">
                      <div v-html="totalinvoiceGroup" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //////////////// -->
    <div v-show="selectedDiv === 'Invoice' || selectedDiv === 'All'" class="row table-row">
      <div class="col-lg-12 col-xl-4 mt-2 px-4">
        <div class="table-header">
          <h6 class="table-title">
            {{ $t('dashboard.due_invoices_card.title') }}
          </h6>
          <router-link to="/supplier/invoices">
            <base-button
              :outline="true"
              color="theme"
              class="btn-sm"
            >
              {{ $t('dashboard.due_invoices_card.view_all') }}
            </base-button>
          </router-link>
        </div>
        <div class="dashboard-table">
          <table-component
            ref="inv_table"
            :data="getDueInvoices"
            :show-filter="false"
            table-class="table"
            class="dashboard"
          >
            <table-column :label="$t('dashboard.due_invoices_card.due_on')" show="formattedDueDate" />
            <table-column
              :label="$t('invoices.customer')"
            >
              <template slot-scope="row">
                <p v-if="row.buyer_stakeholder">
                  <span v-if="row.customer.parent_account_id && row.buyer_stakeholder.details.company && row.buyer_stakeholder.details.company.name">
                    {{ row.buyer_stakeholder.details.company.name }}
                  </span>
                  <span v-else-if="row.customer.parent_account_id==null">
                    {{ row.buyer_stakeholder.details.user.name }}
                  </span>
                <!-- {{row.buyer_stakeholder.details.user.name}} -->
                </p>
            </template></table-column>
            <table-column
              :label="$t('invoices.status')"
              sort-as="status"
            >
              <template slot-scope="row" >
                <span> {{ $t('invoices.status') }}</span>
                <span :class="'inv-status-'+row.status.toLowerCase()">{{ (row.status != 'PARTIALLY_PAID')? row.status : row.status.replace('_', ' ') }}</span>
              </template>
            </table-column>
            <table-column :label="$t('dashboard.due_invoices_card.amount_due')" show="due_amount" sort-as="due_amount">
              <template slot-scope="row">
                <span>{{ $t('dashboard.due_invoices_card.amount_due') }}</span>
                <div v-html="$utils.formatMoney(row.due_amount, row.customer.currency)"/>
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown dashboard-recent-invoice-options no-click"
            >
              <template slot-scope="row">
                <v-dropdown>
                  <a slot="activator" href="#/">
                    <dot-icon />
                  </a>
                  <v-dropdown-item v-if="row.status == 'DRAFT'">
                    <router-link :to="{path: `invoices/${row.id}/edit`}" class="dropdown-item">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon"/>
                      {{ $t('general.edit') }}
                    </router-link>
                  </v-dropdown-item>
                  <v-dropdown-item>
                    <router-link :to="{path: `invoices/${row.id}/view`}" class="dropdown-item">
                      <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                      {{ $t('invoices.view') }}
                    </router-link>
                  </v-dropdown-item>
                  <v-dropdown-item v-if="row.status == 'DRAFT'">
                    <a class="dropdown-item" href="#/" @click="sendInvoice(row)" >
                      <font-awesome-icon icon="envelope" class="dropdown-item-icon" />
                      {{ $t('invoices.send_invoice') }}
                    </a>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
          </table-component>
        </div>
      </div>
      <div class="col-lg-12 col-xl-4 mt-2 mob-table">
        <div class="table-header">
          <h6 class="table-title">
            {{ $t('dashboard.offer_invoices_card.title') }}
          </h6>
          <router-link to="/supplier/invoices">
            <base-button
              :outline="true"
              color="theme"
              class="btn-sm"
            >
              {{ $t('dashboard.offer_invoices_card.view_all') }}
            </base-button>
          </router-link>
        </div>
        <div class="dashboard-table">
          <table-component
            ref="inv_table"
            :data="getOfferInvoices"
            :show-filter="false"
            table-class="table"
            class="dashboard"
          >
            <table-column :label="$t('dashboard.offer_invoices_card.due_on')" show="formattedDueDate" />
            <table-column
              :label="$t('invoices.customer')"
            >
              <template slot-scope="row">
                <p v-if="row.buyer_stakeholder">
                  <span v-if="row.customer.parent_account_id && row.buyer_stakeholder.details.company && row.buyer_stakeholder.details.company.name">
                    {{ row.buyer_stakeholder.details.company.name }}
                  </span>
                  <span v-else-if="row.customer.parent_account_id==null">
                    {{ row.buyer_stakeholder.details.user.name }}
                  </span>
                </p>
              </template>
            </table-column>
            <table-column
              :label="$t('invoices.status')"
              sort-as="status"
            >
              <template slot-scope="row" >
                <span> {{ $t('invoices.status') }}</span>
                <span :class="'inv-status-'+row.status.toLowerCase()">{{ (row.status != 'PARTIALLY_PAID')? row.status : row.status.replace('_', ' ') }}</span>
              </template>
            </table-column>
            <table-column :label="$t('dashboard.offer_invoices_card.amount')" show="due_amount" sort-as="due_amount">
              <template slot-scope="row">
                <span>{{ $t('dashboard.offer_invoices_card.amount') }}</span>
                <div v-html="$utils.formatMoney(row.nominal_amount, row.customer.currency)"/>
              </template>
            </table-column>
            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown dashboard-recent-invoice-options no-click"
            >
              <template slot-scope="row">
                <v-dropdown>
                  <a slot="activator" href="#/">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <router-link :to="{path: `invoices/${row.id}/view`}" class="dropdown-item">
                      <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                      {{ $t('invoices.view') }}
                    </router-link>
                  </v-dropdown-item>
                  <v-dropdown-item v-if="row.pre_pay==1 && row.request_level =='Offered'">
                    <a href="#/" class="dropdown-item" @click="viewOffer(row.id)">
                      <font-awesome-icon :icon="['far', 'comment']" class="dropdown-item-icon" />
                      {{ $t('invoices.view_offer') }}
                    </a>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
          </table-component>
        </div>
      </div>
      <div class="col-lg-12 col-xl-4 mt-2">
        <div class="table-header">
          <h6 class="table-title">
            Rate of Pre-Payment
          </h6>
        </div>
        <div class="dashboard-table">
          <table-component
            ref="inv_table"
            :data="getRateOfPrePayment"
            :show-filter="false"
            table-class="table"
            class="dashboard"
          >
            <table-column label="Funder" show="name" />
            <table-column label="Spread">
              <template slot-scope="row">
                {{ (parseFloat(row.value)).toFixed(2) }}%
              </template>
            </table-column>
            <table-column label="Kibor">
              <template slot-scope="row">
                {{ (Number(row.kibor_amount)).toFixed(2) }}%
              </template>
            </table-column>
            <table-column label="Rate of Prepayment">
              <template slot-scope="row">
                {{ (Number(row.value) + Number(row.kibor_amount)).toFixed(2) }}%
              </template>
            </table-column>
          </table-component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import LineChart from '../../components/chartjs/LineChart'
import BarChart from '../../components/chartjs/BarChart'
import PieChart from '../../components/chartjs/PieChart'
import DollarIcon from '../../components/icon/DollarIcon'
import ContactIcon from '../../components/icon/ContactIcon'
import InvoiceIcon from '../../components/icon/InvoiceIcon'
import EstimateIcon from '../../components/icon/EstimateIcon'
export default {
  components: {
    PieChart,
    LineChart,
    BarChart,
    DollarIcon,
    ContactIcon,
    InvoiceIcon,
    EstimateIcon
  },
  data () {
    return {
      selectedDiv: 'All',
      preapprovedInvoiceGroupCount: [],
      hoverBgColors: [],
      bgColors: ['#334CFF', '#E333FF', '#33FF71', '#F9FF33', '#FFB233', '#FF3F33'],
      values: [20, 20, 5, 9, 7],
      labels: ['Pending', 'Offered', 'Financed', 'Prepaid', 'Settlement', 'Rejected'],
      isLoaded: false,
      years: ['This year', 'Previous year'],
      selectedYear: 'This year',
      invoiceType: ['All', 'Invoice', 'Preapproved Invoice'],
      selectedFunder: null,
      updateChart: true,
      financedAmount: 0,
      PieData: [100, 900],
      CreditLimitBgColors: ['#33FF71', '#FF3F33'],
      CreditLimitData: [],
      fundedAmount: 0,
      total_credit_limit: 0
    }
  },
  computed: {
    ...mapGetters('user', {
      'user': 'currentUser'
    }),
    ...mapGetters('dashboard', [
      'getFunders',
      'getChartMonths',
      'getChartInvoices',
      'getChartOutstandingInvoices',
      'getChartExpenses',
      'getNetProfits',
      'getReceiptTotals',
      'getContacts',
      'getInvoices',
      'getEstimates',
      'getPurchaseOrders',
      'getTotalDueAmount',
      'getTotalOutstandingInvoices',
      'getTotalSales',
      'getTotalReceipts',
      'getTotalExpenses',
      'getNetProfit',
      'getLoadedData',
      'getDueInvoices',
      'getOfferInvoices',
      'getRecentEstimates',
      'invoiceGroupCount',
      'preapprovedInvoiceGroupCount',
      'funderCreditLimitChart',
      'getRateOfPrePayment'
    ]),
    ...mapGetters('currency', [
      'defaultCurrency'
    ]),
    totalinvoiceGroup () {
      return this.invoiceGroupCount.reduce((acc, item) => acc + item, 0)
    },
    totalpreapprovedinvoiceGroup () {
      return this.preapprovedInvoiceGroupCount.reduce((acc, item) => acc + item, 0)
    }
  },
  watch: {
    selectedYear (val) {
      if (val === 'Previous year') {
        let params = {previous_year: true}
        this.loadData(params)
      } else {
        this.loadData()
      }
    },
    selectedFunder (val) {
      if (val != null) {
        this.updateChart = true
        let params = {funder_company_id: val.company_id}
        this.loadData(params)
      } else {
        this.loadData()
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
  },
  methods: {
    ...mapActions('dashboard', [
      'getChart',
      'loadData'
    ]),
    ...mapActions('invoice', [
      'deleteInvoice',
      'sendEmail',
      'markAsSent'
    ]),
    ...mapActions('estimate', [
      'deleteEstimate',
      'markAsAccepted',
      'markAsRejected',
      'convertToInvoice'
    ]),
    ...mapActions('estimate', {
      'sendEstimateEmail': 'sendEmail',
      'markEstimateAsSent': 'markAsSent'
    }),
    processPreapprovedData (newData) {
      this.preapprovedInvoiceGroupCount = [...newData]
    },
    async loadData (params) {
      let res = await this.$store.dispatch('dashboard/loadData', params)
      if (res.data.funder === true) {
        this.updateChart = true
      }
      this.financedAmount = res.data.financedAmount
      this.CrditLimitLabels = res.data.credit_limit_data.labels
      this.total_credit_limit = (res.data.credit_limit_data.total_credit_limit)/100
      this.CreditLimitData = res.data.credit_limit_data.chart
      if (res.data.preapprovedInvoiceGroupCount) {
        this.preapprovedInvoiceGroupCount = [...res.data.preapprovedInvoiceGroupCount]
      }
      this.isLoaded = true
    },
    async removeEstimate (id) {
      this.id = id
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('estimates.confirm_delete', 1),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.deleteEstimate(this.id)
          if (res.data.success) {
            window.toastr['success'](this.$tc('estimates.deleted_message', 1))
            this.refreshEstTable()
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
    refreshInvTable () {
      this.$refs.inv_table.refresh()
    },
    refreshEstTable () {
      this.$refs.est_table.refresh()
    },
    async convertInToinvoice (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('estimates.confirm_conversion'),
        icon: '/assets/icon/file-alt-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.convertToInvoice(id)
          this.selectAllField = false
          if (res.data) {
            window.toastr['success'](this.$t('estimates.conversion_message'))
            this.$router.push(`invoices/${res.data.invoice.id}/edit`)
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
    async onMarkAsSent (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('estimates.confirm_mark_as_sent'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willMarkAsSent) => {
        if (willMarkAsSent) {
          const data = {
            id: id
          }
          let response = await this.markEstimateAsSent(data)
          this.refreshEstTable()
          if (response.data) {
            window.toastr['success'](this.$tc('estimates.mark_as_sent_successfully'))
          }
        }
      })
    },
    async removeInvoice (id) {
      this.id = id
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('invoices.confirm_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          let res = await this.deleteInvoice(this.id)
          if (res.data.success) {
            window.toastr['success'](this.$tc('invoices.deleted_message'))
            this.refreshInvTable()
          } else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
    async sendInvoice (row) {
      if (row.attachments.length > 0) {
        swal({
          title: this.$t('general.are_you_sure'),
          text: this.$t('invoices.confirm_send'),
          icon: '/assets/icon/paper-plane-solid.svg',
          buttons: true,
          dangerMode: true
        }).then(async (value) => {
          console.log(value)
          if (value) {
            const data = {
              invoice_id: row.id
            }
            let response = await this.sendEmail(data)
            this.refreshTable()
            if (response.data.success) {
              window.toastr['success'](this.$tc('invoices.send_invoice_successfully'))
              if (row.pre_pay == 1) {
                this.showPrePaymentRequestPopup(row.id)
              }
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](this.$tc('invoices.user_email_does_not_exist'))
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      } else {
        swal({
          title: this.$t('general.attach_documents'),
          text: this.$t('invoices.without_attachments_you_cant_sent'),
          icon: '/assets/icon/file-alt-solid.svg',
          buttons: true,
          dangerMode: true,
          buttons: {
            buttonOne: {
              text: 'Continue Anyway',
              value: 'continue_anyway',
              visible: true,
              className: 'swal-button--cancel',
              closeModal: true
            },
            buttonTwo: {
              text: 'Go to Attachments',
              value: 'go_to_attachments',
              visible: true,
              className: 'swal-button--danger',
              closeModal: true
            }
          }
        }).then(async (goToAttachment) => {
          if (goToAttachment === 'go_to_attachments') {
            this.$router.push(`/supplier/invoices/${row.id}/attachment`)
          } else if (goToAttachment === 'continue_anyway') {
            const data = {
              invoice_id: row.id
            }
            let response = await this.sendEmail(data)
            this.refreshInvTable()
            if (response.data.success) {
              window.toastr['success'](this.$tc('invoices.send_invoice_successfully'))
              if (row.pre_pay == 1) {
                this.showPrePaymentRequestPopup(row.id)
              }
              return true
            }
            if (response.data.error === 'user_email_does_not_exist') {
              window.toastr['error'](this.$tc('invoices.user_email_does_not_exist'))
              return false
            }
            window.toastr['error'](this.$tc('invoices.something_went_wrong'))
          }
        })
      }
    },
    async showPrePaymentRequestPopup (id) {
      swal({
        title: this.$t('invoices.request_apply_for_PrePayment'),
        text: this.$t('invoices.do_you_want_to_apply_for_prepayment_request'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.prepaymentRequest(id)
        } else {
          this.refreshInvTable()
        }
      })
    },
    async prepaymentRequest (id) {
      this.$router.push(`/supplier/prepayments/${id}/request`)
    },
    async sentInvoice (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('invoices.invoice_mark_as_sent'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willMarkAsSend) => {
        if (willMarkAsSend) {
          const data = {
            id: id
          }
          let response = await this.markAsSent(data)
          this.refreshInvTable()
          if (response.data) {
            window.toastr['success'](this.$tc('invoices.mark_as_sent_successfully'))
          }
        }
      })
    },
    async onMarkAsAccepted (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('estimates.confirm_mark_as_accepted'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (markedAsRejected) => {
        if (markedAsRejected) {
          const data = {
            id: id
          }
          let response = await this.markAsAccepted(data)
          this.refreshEstTable()
          if (response.data) {
            this.refreshEstTable()
            window.toastr['success'](this.$tc('estimates.marked_as_accepted_message'))
          }
        }
      })
    },
    async onMarkAsRejected (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('estimates.confirm_mark_as_rejected'),
        icon: '/assets/icon/times-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (markedAsRejected) => {
        if (markedAsRejected) {
          const data = {
            id: id
          }
          let response = await this.markAsRejected(data)
          this.refreshEstTable()
          if (response.data) {
            this.refreshEstTable()
            window.toastr['success'](this.$tc('estimates.marked_as_rejected_message'))
          }
        }
      })
    },
    async viewOffer (id) {
      this.$router.push(`/supplier/prepayments/${id}/offer`)
    },
    nomailAmount (row) {
      let subTotal = row.sub_total
      let nomailAmount = 0
      let taxes = null
      if (row.taxes) {
        taxes = row.taxes.filter(function (obj) {
          return obj.operator !== 'Subtract'
        })
        if (taxes.length > 0) {
          nomailAmount = subTotal + taxes.map(o => o.amount).reduce((a, c) => { return a + c })
        } else {
          nomailAmount = row.sub_total
        }
      }
      return nomailAmount
    },
    async sendEstimate (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('estimates.confirm_send_estimate'),
        icon: '/assets/icon/paper-plane-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willSendEstimate) => {
        if (willSendEstimate) {
          const data = {
            id: id
          }
          let response = await this.sendEstimateEmail(data)
          this.refreshEstTable()
          if (response.data.success) {
            window.toastr['success'](this.$tc('estimates.send_estimate_successfully'))
            return true
          }
          if (response.data.error === 'user_email_does_not_exist') {
            window.toastr['error'](this.$tc('estimates.user_email_does_not_exist'))
            return true
          }
          window.toastr['error'](this.$tc('estimates.something_went_wrong'))
        }
      })
    }
  }
}
</script>
